import React from "react";
import { ContentFormatter, Icon, Type } from "@ebscois/react-component-library";

import { AccordionHeaderWrapper, StyledAccordion } from "./_styled";

export default function accordionProcessor({ supplemental }) {
  const processSecondaryContent = (
    children,
    wrapperNode,
    processDefaultNode
  ) => {
    const title = children.shift();

    return (
      <StyledAccordion
        toggleText={title}
        variant="secondary"
        className="accordion"
        padding={false}
        data-testid="secondary-accordion"
      >
        {processDefaultNode(wrapperNode, children)}
      </StyledAccordion>
    );
  };

  const processAccordionContent = (
    node,
    processContentPage,
    accordion,
    children
  ) => {
    const title = node.attribs["data-value"];
    const referenceId = node.attribs["data-reference-id"];
    const content = supplemental[referenceId]?.data;
    const type = node.attribs["data-of-type"];
    const icon = accordion.icons[type];

    if (!icon) {
      return ContentFormatter.processDefaultNode(node, children);
    }

    if (!content) {
      // We were given a referenceId that doesn't exist, let's log it
      window?.DD_RUM?.addError(
        new Error(
          `${title} Accordion content was given a referenceId that does not exist, referenceId: ${referenceId}`
        ),
        {
          scope: "platform-content",
          team: "cd.mergeconflict",
        }
      );
    }

    const accordionHeader = (
      <AccordionHeaderWrapper container align={{ item: "center" }}>
        <Icon icon={{ glyph: icon, color: "gray600", size: "md" }} />
        <Type element="span" fontSize="lg">
          {title}
        </Type>
      </AccordionHeaderWrapper>
    );
    return (
      <StyledAccordion
        toggleText={accordionHeader}
        data-testid={`${type}-accordion`}
      >
        <ContentFormatter preProcessors={[processContentPage()]}>
          {content}
        </ContentFormatter>
      </StyledAccordion>
    );
  };

  return { processSecondaryContent, processAccordionContent };
}
